import axios from "axios";

// axios 인스턴스 생성
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// 요청 인터셉터
axiosInstance.interceptors.request.use(
  (config) => {
    /**
     * 로그인/회원가입/이메일 인증 요청처럼
     * 토큰이 필요 없는 요청은 skipAuth: true 옵션 사용
     */
    if (config.skipAuth) {
      // Authorization 제거 (있으면 삭제)
      if (config.headers?.Authorization) {
        delete config.headers.Authorization;
      }
      return config;
    }

    // 토큰 자동 추가
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;

    // ❗ 401 Unauthorized: 로그인 만료 처리
    if (status === 401) {
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");

      // ❗ 바로 redirect
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
